import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import Input from "../../../../../../stories/Input/Input";
import
{
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../../utils/Enum.keys";
import
{
  getModifiedScrollHeight,
  handleMUISelectEvent,
  toInputStandardDate,
  toIsoDate,
} from "../../../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import Compare from "../../../../../../images/Compare.svg";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import
{
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../../../utils/types";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import Nodata from "../../../../../../images/NoData.svg";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import EyeIcon from "../../../../../../images/EyeWhite.svg";
import { useLazyQuery } from "@apollo/client";
import
{
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../../utils/constants";

import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import
{
  AtsRfqMstEdge,
  AtsRfqMstOrderField,
  GetRfqsResult,
  GetRfqsVars,
  RfqQueryType,
} from "../queries/types";
import { GetRfqs } from "../queries/queries";
import { AppContext } from "../../../../../../context/context";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import { formDates } from "../../material/ApprovedList";
import { payloadTypes } from "../../../../../../context/reducer";
import LoadingModal from "../../../../../pages/LoadingModal";
import Navbar from "../../../../../common/layout/Navbar";
import { LicenseTypes } from "../../../../../../utils/Enum.types";

const MaterialQuotationComparison = () =>
{
  const navigate = useNavigate();
  const { Purchase } = useAssetTableJson();
  const { customer_id, company_id } = useUrlParams();

  const { state, dispatch } = useContext( AppContext );
  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [ dates, setDates ] = useState<formDates>( {
    startDate: "",
    endDate: "",
  } );

  const [ message, setMessage ] = useState( emptyMessage );
  const [ searchData, setSearchData ] = useState( "" );
  const [ hasNextPage, setHasNextPage ] = useState<boolean>( true );
  const [ endCursor, setEndCursor ] = useState<string | null>( null );
  const [ categories, setCategories ] = useState<AtsRfqMstEdge[]>( [] );
  const [ rows, setRows ] = useState<GridValidRowModel[]>( [] );
  const [ deleteModal, setDeleteModal ] = useState( false );
  const [ filterStatus, setFilterStatus ] = useState( RfqQueryType.ALL );

  const [ GetRFQ, { loading, data, fetchMore } ] = useLazyQuery<
    GetRfqsResult,
    GetRfqsVars
  >( GetRfqs );

  const rfqTypeOptions = Object.values( RfqQueryType );
  const dynamicHeaders: TableHeaderProps[] =
    Purchase.Quotation.Comparision.MQComparision.map( ( header ) => ( {
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: ( params ) =>
      {
        if ( header.field === "actions" )
        {
          return (
            <>
              {/* <button className="mq-comparision__tableblock--compare" onClick={()=>navigate(`/assets/purchase/${customer_id}/mqcomparision/negotiation`)}>
                Compare <img src={Assign} alt="" />
              </button> */}
              <button
                className="mq-comparision__tableblock--view"
                onClick={() =>
                {
                  dispatch( {
                    type: payloadTypes.SET_RFQ_NO,
                    payload: { rfqNo: params.row.rfq_no },
                  } );
                  navigate(
                    `/${ customer_id }/company/${ company_id }/purchase/mqcomparision/${ params.row.rfq_id }/view`
                  );
                }}
              >
                View <img src={EyeIcon} alt="" />
              </button>
            </>
          );
        } else return params.value;
      },
    } ) );

  const columns: GridColDef[] = [ ...dynamicHeaders ];
  const [ columnVisibilityModel, setColumnVisibilityModel ] =
    useState<GridColumnVisibilityModel>( {} );

  useEffect( () =>
  {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MATERIAL_REQUEST_COMPARISION
    );
    if ( savedModel )
    {
      setColumnVisibilityModel( JSON.parse( savedModel ) );
    }
  }, [] );

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) =>
  {
    setColumnVisibilityModel( newModel );
    localStorage.setItem(
      ColumnVisibilityFor.MATERIAL_REQUEST_COMPARISION,
      JSON.stringify( newModel )
    );
  };

  useEffect( () =>
  {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[ 0 ] as Element;
    const handleScroll = ( e: Event ) =>
    {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if ( scrollTop + clientHeight >= getModifiedScrollHeight( scrollHeight ) )
      {
        if ( hasNextPage && !loading )
        {
          fetchMore( {
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: ( prevResult, { fetchMoreResult } ) =>
            {
              if ( !fetchMoreResult ) return prevResult;

              const newEdges = fetchMoreResult.GetRfqs.edges;
              const pageInfo = fetchMoreResult.GetRfqs.pageInfo;
              setEndCursor( pageInfo.endCursor );
              setHasNextPage( pageInfo.hasNextPage );

              const duplicateCheck = prevResult.GetRfqs.edges.filter(
                ( { node: { id } } ) =>
                  newEdges.findIndex(
                    ( { node: { id: newId } } ) => newId === id
                  ) !== -1
              );

              if ( duplicateCheck.length > 0 ) return prevResult;

              return {
                GetRfqs: {
                  edges: [ ...categories, ...newEdges ],
                  pageInfo,
                  totalCount: data ? data.GetRfqs.totalCount! : 0,
                },
              };
            },
          } );
        }
      }
    };
    if ( scrollTable && rows.length )
      scrollTable.addEventListener( "scroll", handleScroll );

    return () =>
    {
      if ( scrollTable ) scrollTable.removeEventListener( "scroll", handleScroll );
    };
  }, [ rows ] );

  useEffect( () =>
  {
    if ( data && !loading )
    {
      const newData = data.GetRfqs.edges;

      if ( endCursor )
      {
        const updatedNewData = newData.map( ( newCompany ) =>
        {
          const filteredStudent = categories.find(
            ( employee ) => employee.node.id === newCompany.node.id
          );
          if ( filteredStudent )
          {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        } );
        setCategories( updatedNewData );
        setRows(
          updatedNewData.map( ( { node }, index ) => ( {
            id: index + 1,
            rfq_id: node.id,
            rfq_date: node.rfqDate,
            rfq_no: node.rfqNo,
            last_date_for_submission: toInputStandardDate(
              node.lastDateRfqSubmission
            ),
            rfq_prepared_by: node.raisedUserDetails.name,
            // rfq_authorized_by: data.authorized_by,
            remarks: node.remarks,
            rfq_comparision_date: toInputStandardDate( node.comprMadeDate ),
            comparision_inspected_by: node.comprUserDetails.name,
            comparision_remarks: node.comprRemarks,
            finalized_quotation: node.completed,
          } ) )
        );
      } else
      {
        setCategories( newData );
        setRows(
          newData.map( ( { node }, index ) => ( {
            id: index + 1,
            rfq_id: node.id,
            rfq_date: node.rfqDate,
            rfq_no: node.rfqNo,
            last_date_for_submission: toInputStandardDate(
              node.lastDateRfqSubmission
            ),
            rfq_prepared_by: node.raisedUserDetails.name,
            // rfq_authorized_by: data.authorized_by,
            remarks: node.remarks,
            rfq_comparision_date: toInputStandardDate( node.comprMadeDate ),
            comparision_inspected_by: node.comprUserDetails.name,
            comparision_remarks: node.comprRemarks,
            finalized_quotation: node.completed,
          } ) )
        );
      }
      setEndCursor( data.GetRfqs.pageInfo.endCursor );
    }
    // eslint-disable-next-line
  }, [ data, loading ] );

  useEffect( () =>
  {
    if ( customer_id && state.ActiveFinYr )
    {
      GetRFQ( {
        variables: {

          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          name: searchData ? searchData : EMPTY_STRING,
          end_date: toIsoDate( dates.endDate ),
          start_date: toIsoDate( dates.startDate ),
          queryType: filterStatus,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsRfqMstOrderField.RFQ_DATE,
          },
        },
      } );
    }
  }, [
    customer_id,
    state.ActiveFinYr,
    GetRFQ,
    dates.endDate,
    dates.startDate,
    filterStatus,
    searchData,
  ] );

  useEffect( () =>
  {
    if ( todaysDateData && serverDate )
    {
      const getMonth = new Date( serverDate ).getMonth();
      const getYear = new Date( serverDate ).getFullYear();

      const firstDay = new Date( getYear, getMonth, 1 ); // First day of the month
      const lastDay = new Date( getYear, getMonth + 1, 0 );

      setDates( {
        endDate: lastDay.toString(),
        startDate: firstDay.toString(),
      } );
    }
  }, [ todaysDateData, serverDate ] );

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>Material Quotation Comparision</Title>
      <div className="mq-comparision">
        <div className="mq-comparision__filters row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search by RFQ No."
              onChange={( e ) => setSearchData( e.target.value )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={( e ) =>
              {
                if ( e.key === Keys.ENTER )
                {
                  e.preventDefault();
                  handleMUISelectEvent( e );
                }
              }}
              options={rfqTypeOptions}
              onChange={( event, newValue ) =>
                setFilterStatus( newValue as RfqQueryType )
              }
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={( params ) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Filter Quotation Type"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col"></div>
          <div className="col-4 mq-comparision__filters--flex">
            <TextField
              label="Start Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className="mq-comparision__filters--date"
              type="date"
              value={toInputStandardDate( dates.startDate )}
              onChange={( e ) =>
              {
                setDates( {
                  ...dates,
                  startDate: e.target.value,
                } );
              }}
            />
            <img
              src={Compare}
              alt=""
              className="mq-comparision__filters--compare"
            />
            <TextField
              label="End Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className="mq-comparision__filters--date"
              type="date"
              value={toInputStandardDate( dates.endDate )}
              onChange={( e ) =>
              {
                setDates( {
                  ...dates,
                  endDate: e.target.value,
                } );
              }}
            />
          </div>
        </div>
        <div className="mq-comparision__tableblock">
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={Nodata} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <Button mode="back" onClick={() => navigate( -1 )} />
      </div>

      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
      // handleDelete={HandleDelete}
      />
      <LoadingModal flag={(!searchData && loading)} />
    </>
  );
};

export default MaterialQuotationComparison;
